import { ChiptaElement, html, css } from 'chipta-libs/main.js';


class IconArrowRight extends ChiptaElement {

  render() {
    return html`
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <line x1="5" y1="12" x2="19" y2="12"></line>
        <polyline points="12 5 19 12 12 19"></polyline>
      </svg>
    `;
  }

  static get styles() {
    return css`
      svg {
        display: block;
        width: 1.25em;
        height: 1.25em;
        margin-left: .25em;
      }
    `;
  }

}

customElements.define('icon-arrow-right', IconArrowRight);
